import React from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import { phoneModalNumberState, phoneModalState } from './atom'
import { ModalBase, Text, Stack } from '@/presentation/components'
import { Linking, Alert } from 'react-native'
import { theme } from '@/presentation/styles'
import { Button } from 'react-native-paper'

export const PhoneModal: React.FC = () => {
  const [modalIsOpen, setModalOpen] = useRecoilState(phoneModalState)
  const phoneNumber = useRecoilValue(phoneModalNumberState)

  if (!phoneNumber) {
    return null
  }

  const phoneNumbers = phoneNumber.split('\n').filter(phone => phone.trim() !== '')

  const handleCloseModal = (): void => {
    setModalOpen(false)
  }

  const handleCall = async (phone: string): Promise<void> => {
    const treatedPhone = phone.includes(':') ? phone.split(':')[1].trim() : phone.trim()
    const url = `tel:${treatedPhone}`
    const supported = await Linking.canOpenURL(url)

    if (supported) {
      await Linking.openURL(url)
    } else {
      Alert.alert('Error', 'Erro ao ligar')
    }
  }

  return (
    <ModalBase
      visible={modalIsOpen}
      onClose={handleCloseModal}
      key={`id-${phoneNumber}`}
    >
      <Text variant='h6'>Contato(s)</Text>
      <Stack style={{ gap: 2 }}>
        {phoneNumbers.map((phone, index) => {
          const treatedPhoneNumber = phone.includes(':') ? phone.split(':')[1].trim() : phone.trim()

          return (
            <Stack
              key={index}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 2
              }}
            >
              <Text variant='body1'>{treatedPhoneNumber}</Text>
              <Button
                icon='phone'
                onPress={async () => await handleCall(phone)}
                buttonColor={theme.colors.info}
                textColor={theme.colors.white}
              >
                Ligar
              </Button>
            </Stack>
          )
        })}
      </Stack>
    </ModalBase>
  )
}
